import { FlyToInterpolator } from "@deck.gl/core";

const DEFAULT_TIME = 1000;

export default class DynamicFlyToInterpolator extends FlyToInterpolator {
  constructor({
    minTime = DEFAULT_TIME,
    maxTime = DEFAULT_TIME,
    breakAngle = 0,
  }) {
    super(["longitude", "latitude"]);

    this.minTime = minTime;
    this.maxTime = maxTime;
    this.breakAngle = breakAngle;
  }

  getDuration(startViewState, endViewState) {
    const deltaLat = Math.abs(startViewState.latitude - endViewState.latitude);
    const deltaLng = Math.abs(
      startViewState.longitude - endViewState.longitude
    );

    if (deltaLat > this.breakAngle || deltaLng > this.breakAngle) {
      // distance between countries is huge, flight duration is set to 3 seconds
      return this.maxTime;
    }

    return this.minTime;
  }
}
